import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, DeferLoadingStrategy, provideConfig } from '@spartacus/core';
import { QualtricsService } from 'src/app/service/qualtrics/qualtrics.service';
import { QualtricsComponent } from './qualtrics/qualtrics.component';

@NgModule({
  imports: [CommonModule],
  providers: [
    QualtricsService,
    provideConfig(<CmsConfig>{
      cmsComponents: {
        QualtricsComponent: {
          component: QualtricsComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    }),
  ],
  declarations: [QualtricsComponent],
  exports: [QualtricsComponent],
})
export class QualtricsModule {}
